/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_3_QuestionInputs */

const en_gc_search_guides_gridcraft_online_sections_7_questions_3_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I return later using the same editor link?`)
};

const zh_gc_search_guides_gridcraft_online_sections_7_questions_3_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`之后能否通过同一个编辑器链接继续？`)
};

/**
* | output |
* | --- |
* | "Can I return later using the same editor link?" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_3_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_7_questions_3_question = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_3_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_3_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_7_questions_3_question(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_7_questions_3_question(inputs)
});
export { gc_search_guides_gridcraft_online_sections_7_questions_3_question as "gc.search_guides.gridcraft_online.sections.7.questions.3.question" }